import {
	MarketCategory,
	PERP_MARKET_CATEGORIES_CONFIG,
} from 'src/constants/markets';
import ScrollShadows from 'src/components/ScrollShadows';
import { useRef, memo } from 'react';
import Tabs from 'src/components/primitives/Tabs/Tabs';

// Spot trading is disabled on the smart contract side, so hide the spot category.
const OPTIONS = PERP_MARKET_CATEGORIES_CONFIG.filter(
	(option) => option.value !== 'spot'
);

function MarketCategoryTabs({
	selectedCategory,
	setSelectedCategory,
}: {
	selectedCategory: MarketCategory;
	setSelectedCategory: (category: MarketCategory) => void;
}) {
	const scrollableRef = useRef<HTMLDivElement>(null);

	if (OPTIONS.length === 1) {
		return null;
	}

	return (
		<ScrollShadows
			scrollableRef={scrollableRef}
			gradientFromClassName="from-container-bg"
		>
			<div
				className="hidden-scroll flex max-w-full items-center gap-1 overflow-x-auto"
				ref={scrollableRef}
			>
				<Tabs
					size="sm"
					variant="secondary"
					options={OPTIONS}
					activeTab={selectedCategory}
					onTabChange={setSelectedCategory}
				/>
			</div>
		</ScrollShadows>
	);
}

export default memo(MarketCategoryTabs);
